// TODO: implement About section
class AboutController {
  constructor() {
    this.title = 'About';
  }
}

export { AboutController };



/** WEBPACK FOOTER **
 ** ./client/app/components/about/about.controller.js
 **/